var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1609 18.0967C9.4141 18.2428 9.70133 18.3198 9.9937 18.3198C10.2861 18.3198 10.5733 18.2428 10.8265 18.0967L16.6561 14.7655C16.909 14.6194 17.1191 14.4094 17.2653 14.1566C17.4115 13.9037 17.4886 13.6168 17.4889 13.3247V6.66236C17.4886 6.37028 17.4115 6.08341 17.2653 5.83054C17.1191 5.57766 16.909 5.36767 16.6561 5.22163L10.8265 1.89044C10.5733 1.74426 10.2861 1.6673 9.9937 1.6673C9.70133 1.6673 9.4141 1.74426 9.1609 1.89044L3.33133 5.22163C3.07838 5.36767 2.86828 5.57766 2.72211 5.83054C2.57594 6.08341 2.49883 6.37028 2.49854 6.66236V13.3247C2.49883 13.6168 2.57594 13.9037 2.72211 14.1566C2.86828 14.4094 3.07838 14.6194 3.33133 14.7655L9.1609 18.0967Z",
    stroke: "white",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99365 18.3215V9.99356",
    stroke: "white",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73975 5.82956L9.9934 9.99354L17.247 5.82956",
    stroke: "white",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24609 3.55603L13.7413 7.84493",
    stroke: "white",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.351457e8bc8300e107d24ba67d6e80c3.svg";
export { ForwardRef as ReactComponent };